export enum LOADING_STATUS {
    LOADING = "loading",
    SUCCESS = "success",
    ERROR = "error",
    EMPTY = "empty",
    IDLE = "idle",
}
